import { render } from "./ChatAvatar.vue?vue&type=template&id=7041c9ae&scoped=true&ts=true"
import script from "./ChatAvatar.vue?vue&type=script&lang=ts"
export * from "./ChatAvatar.vue?vue&type=script&lang=ts"

import "./ChatAvatar.vue?vue&type=style&index=0&id=7041c9ae&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7041c9ae"]])

export default __exports__